//import React from 'react';
import React, { useState, useContext } from "react";
import { useLocation } from '@reach/router';

// Interfaces //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles //
import "./libraryQuote.scss"

import LikeButton from '../../molecules/like-button/like-button';
import { CONTENT_TYPE_ARTICULO } from "../../../services/social.services";
import GlobalContext from "../../../contexts/globalContext";
import ShareModal from "../../molecules/share-modal/shareModal";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { navigate } from "gatsby";
import { getToken, getCmdFormData } from "../../../services/formServices";

// Utils //
import { splitButtonText } from "../../../utils/helpers";

export enum BACKGROUND_COLOR {
    Aguamarina = "Aguamarina",
    Crema = "Crema",
    Verde = "Verde"
}

const LibraryQuote = (props: ReferenciaContenido) => {
    const referenciaFrase = props.referenciaFrase[0].fields ? props.referenciaFrase[0].fields : props.referenciaFrase[0] ;

    const [visibility, setVisibility] = useState(false);
    const { isBrowser } = useBrowserMode();
    const [currentUrl, setCurrentUrl] = useState("");

    //limita el remderizado de botones likes y compartir unicamnete para la pagina de biblioteca home
    const location = useLocation();
    const isBibliotecaPage = location.pathname.endsWith("/biblioteca/");
    
    const onClickShare = (e) => {
        setVisibility(e);
    };
    const setLinkUrl = (url: string) => {
        setCurrentUrl(url)
    }

    const popupCloseHandler = (e) => {
        setVisibility(e);
    };

    const quoteEntryIdContentful = referenciaFrase.contentful_id;
    
    const Context = useContext(GlobalContext);

    const handleIngresaAction = async () => {
        if (Context.gigyaContext.gigyaAccount) {
            redirect();
        }
        else {
            Context.gigyaContext.login();
        }
    }

    const redirect = async () => {
        let responseData:any = await checkUserRegistered();
        if (responseData.data.answerData && responseData.data.answerData.documentId) {
            navigate(splitButtonText(props.redireccionBoton,1));
        }
        else{
            navigate(splitButtonText(props.redireccionBoton,0));
        }
    }

    const checkUserRegistered = async () => {
        const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
        const response = await getCmdFormData(Context!.gigyaContext!.gigyaAccount!.data.docNumber, token);
        return response;
    }
        
    return (
        <div className={`o-library-quote ${BACKGROUND_COLOR[referenciaFrase.colorFondo]}`}>
            <div className='container'>
                <div className='o-library-quote__content'>
                    <i className="icon-quote-left"></i>
                    <i className="icon-quote-right"></i>
                    <div className='quote'>
                        <p>{referenciaFrase.textoInspirador}</p>
                    </div>
                    <p className='author'>{referenciaFrase.autor}</p>
                </div>
                {isBibliotecaPage && ( 
                    <div className='o-library-quote__likes'>
                        <LikeButton contentId={quoteEntryIdContentful} contentType={CONTENT_TYPE_ARTICULO}/>
                    </div> )}
                    {Context.gigyaContext.gigyaAccount ? isBibliotecaPage && (
                        <div className='o-library-quote__share'>
                            <div className='share'>
                                <i className="icon-share" />
                                <span className={`gtm_compartirfrase_${window.location.pathname.split('/')[2]}`}
                                    onClick={() => {
                                        onClickShare(true);
                                        setLinkUrl(
                                            encodeURIComponent(
                                                `${
                                                    isBrowser
                                                        ? window.location.origin
                                                        : ""
                                                }/${location.pathname.split('/')[3]}/biblioteca`
                                            )
                                        );
                                    }}
                                >
                                    Compartir
                                </span>
                            </div>
                        </div>
                        ) : (isBibliotecaPage && (
                            <div className='o-library-quote__share'>
                                <div className='share'>
                                    <i className="icon-share" />
                                    <span className={`gtm_compartirfrase_${window.location.pathname.split('/')[2]}`}                                        
                                        onClick={handleIngresaAction}>
                                        Compartir
                                    </span>
                                </div>
                            </div>
                            ))
                    }
                {isBibliotecaPage && (<ShareModal isOpen={visibility} onClose={popupCloseHandler} link={currentUrl} />)}                
            </div>
        </div>
    )
}

export default LibraryQuote;
